import React from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { useForm, useField } from "@tanstack/react-form";
import { login } from "../../api/auth";

export default function Login() {
  const navigate = useNavigate();

  const loginMutation = useMutation({
    mutationFn: login,
    onSuccess: (data) => {
      localStorage.setItem("bigBearJWTToken", data.token);
      navigate("/admin");
    },
  });

  const form = useForm({
    defaultValues: {
      username: "",
      password: "",
    },
    onSubmit: async ({ value }) => {
      loginMutation.mutate(value);
    },
  });

  const usernameField = useField({
    form,
    name: "username",
    validators: {
      onChange: ({ value }) => (!value ? "Username is required" : undefined),
    },
  });

  const passwordField = useField({
    form,
    name: "password",
    validators: {
      onChange: ({ value }) =>
        value.length < 6 ? "Password must be at least 6 characters" : undefined,
    },
  });

  return (
    <div className="flex min-h-[70vh] items-center justify-center px-4">
      <div className="w-full max-w-sm rounded-lg border bg-white p-6 shadow-md">
        <h2 className="mb-6 text-center text-2xl font-semibold text-[#006838]">
          Admin Login
        </h2>

        {loginMutation.isError && (
          <div className="mb-4 text-sm text-red-600">
            {(loginMutation.error as Error).message}
          </div>
        )}

        <form
          onSubmit={(e) => {
            e.preventDefault();
            form.handleSubmit();
          }}
          className="space-y-4"
        >
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Username
            </label>
            <input
              value={usernameField.state.value}
              onChange={(e) => usernameField.handleChange(e.target.value)}
              className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm focus:border-[#006838] focus:outline-none focus:ring-1 focus:ring-[#006838]"
            />
            {usernameField.state.meta.isTouched &&
              usernameField.state.meta.errors.length > 0 && (
                <p className="mt-1 text-sm text-red-600">
                  {usernameField.state.meta.errors[0]}
                </p>
              )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Password
            </label>
            <input
              type="password"
              value={passwordField.state.value}
              onChange={(e) => passwordField.handleChange(e.target.value)}
              className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm focus:border-[#006838] focus:outline-none focus:ring-1 focus:ring-[#006838]"
            />
            {passwordField.state.meta.isTouched &&
              passwordField.state.meta.errors.length > 0 && (
                <p className="mt-1 text-sm text-red-600">
                  {passwordField.state.meta.errors[0]}
                </p>
              )}
          </div>

          <button
            type="submit"
            disabled={loginMutation.isPending}
            className="mt-4 w-full rounded-md bg-[#006838] px-4 py-2 text-white hover:bg-green-800 transition disabled:opacity-50"
          >
            {loginMutation.isPending ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}
